import React from "react";
import { Box, FlexBox, Image } from "../primitives";
import { useAddCommas } from "../../utils";
import { PriceNew, PriceOld } from "./Cards.styled";
import { CardSelected } from "../../type";
import { CSS } from "@stitches/react";
import { InfoTooltip } from "../common/InfoTooltip/InfoTooltip";
import { Condition } from "./Condition";
import { Langugage } from "./Language";
import { useSelector } from "react-redux";
import { selectGame } from "../../store/slices/global";
import {
  CardMarketConditionCodeType,
  CardTraderLanguageValueType,
} from "magic-shared-types";
import {
  CARD_LANGUAGES,
  CONDITION_MAPPING_CARDMARKET_CODE_CARDTRADER,
} from "../../constant";

interface PriceProps {
  card: CardSelected;
  setOpenModalChoosePrice?: (arg1: string | null) => void;
  containerStyled?: CSS;
}

export const Price = ({
  card,
  setOpenModalChoosePrice,
  containerStyled = {},
}: PriceProps) => {
  const addCommas = useAddCommas();
  const game = useSelector(selectGame);

  const hasOriginalPrice =
    typeof card.originalPrice === "number" && card.originalPrice !== card.price;

  const priceDifferencePercent =
    hasOriginalPrice && card?.originalPrice && card.originalPrice !== 0
      ? (
          ((card.price - card.originalPrice) / card.originalPrice) *
          100
        ).toFixed(2)
      : null;

  const renderPrice = () => {
    const priceValue = (
      <PriceNew
        canBeClicked={typeof setOpenModalChoosePrice === "function"}
        onClick={(e) => {
          e.stopPropagation();
          if (typeof setOpenModalChoosePrice === "function") {
            setOpenModalChoosePrice?.(card.uid);
          }
        }}
      >
        {addCommas(card.price)} €
      </PriceNew>
    );

    if (card?.priceTakenInConsiderationCardMarket?.length) {
      return (
        <InfoTooltip
          tooltipCss={{ width: 300, maxWidth: "400px", zIndex: 999999 }}
          content={
            <FlexBox css={{ flexDirection: "column", gap: 10 }}>
              {card?.priceTakenInConsiderationCardMarket?.map((cardPrice) => {
                const cardLanguage = CARD_LANGUAGES?.find(
                  (lang) => lang?.label === cardPrice?.language
                );

                return (
                  <FlexBox css={{ gap: 10, alignItems: "center" }}>
                    <Box>{cardPrice.sellerName}</Box>
                    <Condition
                      condition={
                        CONDITION_MAPPING_CARDMARKET_CODE_CARDTRADER[
                          cardPrice.condition as CardMarketConditionCodeType
                        ]
                      }
                    />
                    <Image
                      src={`${cardLanguage?.flag}`}
                      alt={cardLanguage?.label}
                      css={{ width: 30 }}
                    />
                    <Box>{cardPrice.cardPrice}</Box>
                  </FlexBox>
                );
              })}
            </FlexBox>
          }
        >
          {priceValue}
        </InfoTooltip>
      );
    }

    if (card?.priceTakenInConsiderationCardTrader?.length) {
      return (
        <InfoTooltip
          tooltipCss={{ width: 300, maxWidth: "400px", zIndex: 999999 }}
          content={
            <FlexBox css={{ flexDirection: "column", gap: 10 }}>
              {card?.priceTakenInConsiderationCardTrader?.map((cardPrice) => (
                <FlexBox css={{ gap: 10, alignItems: "center" }}>
                  <Box>{cardPrice.user.username}</Box>
                  <Condition condition={cardPrice.properties_hash.condition} />
                  {cardPrice?.properties_hash?.[
                    `${game.card_trader_game}_language`
                  ] && (
                    <Langugage
                      language={
                        cardPrice.properties_hash[
                          `${game.card_trader_game}_language`
                        ] as CardTraderLanguageValueType
                      }
                    />
                  )}
                  <Box>{cardPrice.price.non_layered_price_formatted}</Box>
                </FlexBox>
              ))}
            </FlexBox>
          }
        >
          {priceValue}
        </InfoTooltip>
      );
    }

    return priceValue;
  };

  return (
    <FlexBox
      css={{
        flexDirection: "column",
        gap: 5,
        alignItems: "center",
        ...containerStyled,
      }}
    >
      {hasOriginalPrice && (
        <>
          {card.originalPrice && (
            <PriceOld>{addCommas(card.originalPrice)} €</PriceOld>
          )}
          {priceDifferencePercent !== null && (
            <span
              style={{
                fontSize: 12,
                color:
                  Number(priceDifferencePercent) > 0 ? "#15803d" : "#b91c1c",
              }}
            >
              {Number(priceDifferencePercent) > 0 ? "+" : ""}
              {priceDifferencePercent}%
            </span>
          )}
        </>
      )}
      {renderPrice()}
    </FlexBox>
  );
};
